import { FC } from "react";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  GroupTemplateRaw,
  ManagerUsersConfigRows,
} from "../../../../../redux/slices/users/createUsers";
import { NavigateFunction } from "react-router-dom";
import { stylesMUIManagers } from "../styles/managersCreationStyles";

type CreateManagersButtonParams = {
  totalErrors: number;
  tryingToCreate: (trying: boolean) => void;
  createManagersService: (navigate: (arg0: string) => unknown) => void;
  groupTemplateRaw: GroupTemplateRaw[];
  createManagers: {
    createSuccess: boolean;
    createLoading: boolean;
    createError: string;
    linkActions: boolean;
    usersManagersCreated: number;
  };
  isValidUsersConfigs: (rows: ManagerUsersConfigRows[]) => boolean;
  managerUsersConfigRows: ManagerUsersConfigRows[];
  navigate: NavigateFunction;
};

const CreateManagersButton: FC<CreateManagersButtonParams> = ({
  totalErrors,
  tryingToCreate,
  createManagersService,
  groupTemplateRaw,
  createManagers,
  isValidUsersConfigs,
  managerUsersConfigRows,
  navigate,
}) => {
  const [t] = useTranslation("global");
  return (
    <Button
      onClick={() => {
        if (totalErrors >= 1) {
          tryingToCreate(true);
        }
        if (totalErrors === 0) {
          tryingToCreate(false);
          createManagersService(navigate);
        }
      }}
      disabled={
        groupTemplateRaw.length === 0 ||
        createManagers.createLoading ||
        managerUsersConfigRows.length === 0 ||
        !isValidUsersConfigs(managerUsersConfigRows)
      }
      sx={stylesMUIManagers.CreateManagersButton}
      variant="contained"
    >
      {t("Create_site.config_users.create")}
    </Button>
  );
};

export default CreateManagersButton;
